import { axios } from 'api'
import NewUserPopup from 'components_v2/Home/SignedIn/NewUserPopup/NewUserPopup'
import React, { useEffect, useState } from 'react'

const HandleNewUserPopup = () => {
  const [pendingSilentWelcomeEmail, setPendingSilentWelcomeEmail] =
    useState(null)
  useEffect(() => {
    axios
      .get('/alo_token_auth/pending_silent_welcome')
      .then((res) => {
        if (res?.data?.pending) {
          setPendingSilentWelcomeEmail(res.data.email || '')
        }
      })
      .catch(() => {})
  }, [])
  return (
    <>
      {pendingSilentWelcomeEmail && (
        <NewUserPopup
          showSignOut
          createAccountOnContinue
          email={pendingSilentWelcomeEmail}
        />
      )}
    </>
  )
}

export default HandleNewUserPopup
